const isEmail = (input: string) => (
  typeof input === 'string' && input.indexOf('@') > -1
);

export default isEmail;
